// ANCHOR React
import { memo } from 'react';

// ANCHOR Img
import { Img } from '@lyon/components/image';

// ANCHOR Base
import { Block, BlockOverrides } from 'baseui/block';
import { styled } from 'baseui';
import { StyledLink } from 'baseui/link';

// ANCHOR Utils
import {
  ucarecdn,
  ucarecdnOptimize,
} from '@lyon/utils/ucarecdn';

// ANCHOR Styles
import { StyleObject } from 'styletron-react';
import {
  BLOCK, ROUNDED, IMAGE_SKELETON,
} from './styles';

const CoverImage = styled(Img, IMAGE_SKELETON);

interface IProps {
  name?: string;
  image?: string;
  type?: 'default' | 'rounded';
  overrides?: BlockOverrides;
  linkOverrides?: StyleObject;
}

export const ContentCoverImage = memo(({
  image, name, overrides, linkOverrides, type = 'default',
}: IProps) => {
  const defaultOverrides = type === 'rounded' ? ROUNDED : BLOCK;

  return (
    <StyledLink
      href={ucarecdn(image)}
      target="_blank"
      rel="noreferrer noopener"
      title="View Full Image"
      $style={linkOverrides}
    >
      <Block overrides={overrides ?? defaultOverrides}>
        <CoverImage
          src={ucarecdnOptimize(image ?? '2dac1789-410f-4099-b016-1cfd1efa67c9/-/crop/1600x1118/0,0')}
          alt={name ?? ''}
        />
      </Block>
    </StyledLink>
  );
});
